import { PermisosService, Permisos } from './../../providers/authentication/permisos.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { EspacioFormulario } from '../../domain/EspacioFormulario';
import { RutaSugerida } from './../../domain/RutaSugerida';
import * as allSettled from 'promise-all-settled';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { BreadcrumbService } from '../../breadcrumb.service';
import { TranslateService } from 'ng2-translate';
import { Constantes } from '../../domain/constantes';
import { AppComponent } from '../../app.component';
import { environment } from '../../../environments/environment';
import { nodeValue } from '@angular/core/src/view';
import { forEach } from '@angular/router/src/utils/collection';
import { NuevaRutaSugeridaComponent } from './nuevo/nueva.rutaSugerida.component';
import { Contenido } from '../../domain/Contenido';


@Component({
	templateUrl: './RutasSugeridas.component.html',
    providers: [ConfirmationService]
})
export class RutasSugeridasComponent implements OnInit, OnDestroy {
	@ViewChild('dt') dt_rutas;
	@ViewChild('dt_destacados') dt_rutas_destacadas;
	@ViewChild('NuevaRutaSugeridaComponent') hijo;
	

	public Estado = [
		{
			tipo: 'TODOS',
			value: 4,
			clases: [],
			label: 'RutasSugeridas.estadoTodos'
		},

		{
			tipo: 'PROXIMOACT',
			value: 5,
			clases: [],
			label: 'RutasSugeridas.estadoProximoAct'
		},
		{
			tipo: 'ACTIVO',
			value: 3,
			clases: ['ui-message', 'ui-corner-all', 'ui-messages-success'],
			label: 'RutasSugeridas.estadoActivo'
		},
		
		{
			tipo: 'PROXIMO',
			value: 1,
			clases: ['ui-message', 'ui-messages-warning', 'ui-corner-all'],
			label: 'RutasSugeridas.estadoProximo'
		},
		{
			tipo: 'EXPIRADO',
			value: 0,
			clases: ['ui-message', 'ui-messages-error', 'ui-corner-all'],
			label: 'RutasSugeridas.estadoExpirado'
		}
	];


	//public mensajesExpiradosMod = this.mensajesExpirados[2];
	//public Estado = [];
	public EstadoMod = this.Estado[2];
	
	
	public msgs = [];
	public rutasSugeridas: RutaSugerida[] = [];
	rutasSugeridasDestacar: RutaSugerida[] = [];

	public cols;
	public cols_destacar;


	spinner: HTMLElement;

	public espacioSeleccionado: EspacioFormulario = new EspacioFormulario();
	public rutaSugeridaSeleccionado: RutaSugerida = new RutaSugerida();
	private nuevaRutaSugeridaComponent: NuevaRutaSugeridaComponent;
	/* ** @INPUTS de p-dialog ** */
	public visible: boolean;


	public permisos: Permisos = new Permisos();
	displayDialogPrioridadDestacar: boolean;
	rutaselec: any;

	permiteContenidos: boolean;

	

	constructor(
		private appComponent: AppComponent,
		private router: Router,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private confirmationService: ConfirmationService,
		private breadcrumbService: BreadcrumbService,
		private translate: TranslateService,
		private permisosService: PermisosService
		
	) {

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('RutasSugeridas.rutassugeridas') }
		]);
		/*this.nuevaRutaSugeridaComponent.currentMenu
		.subscribe(menu => {
			this.rutaselec = menu;
		});*/
		console.log('*** RutaSugeridasComponent ***');

		this.cols = [
			{ field: 'Imagen', header: this.translate.instant('RutasSugeridas.imagen') },
			{ field: 'Nombre', header: this.translate.instant('RutasSugeridas.nombre') },
			{ field: 'Descripcion', header: this.translate.instant('RutasSugeridas.descripcion') },
			{ field: 'expirado', header: this.translate.instant('RutasSugeridas.estado') },
			{ field: 'RutaHasContenidos', header: this.translate.instant('RutasSugeridas.nodosasignados') },
			{ field: 'MostrarEdicion', header: '' }
		];

		this.cols_destacar = [
			{ field: 'Drag', header: '' },
			{ field: 'Imagen', header: this.translate.instant('RutasSugeridas.imagen') },
			{ field: 'Nombre', header: this.translate.instant('RutasSugeridas.nombre') },
			//{ field: 'Descripcion', header: this.translate.instant('RutasSugeridas.descripcion') },
			{ field: 'expirado', header: this.translate.instant('RutasSugeridas.estado')},
			{ field: 'RutaHasContenidos', header: this.translate.instant('RutasSugeridas.nodosasignados')},
			{ field: 'Destacado', header: '' },
		];
		
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';
	}


	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';
		
		const idEspacio = this.authService.getIdEspacio();
		this.entityManager.getEspacioById(idEspacio, 'RUTAS_SUGERIDA.FOTOS, RUTAS_SUGERIDA.RUTA_has_CONTENIDOS')
		.then(function (espacio: any) {
			console.log(espacio);
			if (espacio !== undefined) {
				that.espacioSeleccionado.Nombre = espacio.Nombre;
				that.espacioSeleccionado.Descripcion = espacio.Descripcion;
				that.espacioSeleccionado.ENTIDAD = espacio;
				const rutas = that.espacioSeleccionado.ENTIDAD.RUTAS_SUGERIDA;
			
				return that.prepararRutaSugeridasCell(rutas);
			}
			else{
				return false;
			}
		})
		.then(function () {
			return that.comprobarPermisos();
		})
		.then(function () {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			console.log('*** prepararRutaSugeridasCell OK ***');
		})
		.catch(function (e) {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			that.appComponent.showError(e);
			return false;
		});

	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}
	
	onRowReorder(event){
		console.log('-- Rutas Reordenadas.');
		console.log(event);
		//this.rutasSugeridasDestacar = this.moveArrayItemToNewIndex(this.rutasSugeridasDestacar, event.dragIndex, event.dropIndex);
		//this.rutasSugeridas = this.moveArrayItemToNewIndex(this.rutasSugeridas, event.dragIndex, event.dropIndex);

	}


	moveArrayItemToNewIndex(arr, old_index, new_index) {
		if (new_index >= arr.length) {
			let k = new_index - arr.length + 1;
			while (k--) {
				arr.push(undefined);
			}
		}
		arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
		return arr; 
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	addNuevaRutaSugerida() {
		this.router.navigate(['/rutas-sugeridas/nueva', {}]);
	}

	editarRutaSugerida(elemento: any) {
		if(this.rutaSugeridaSeleccionado.FechaBaja !== null){
			this.permiteContenidos = true;
		}
		else{
			this.permiteContenidos = false;
		}
		this.router.navigate(['/rutas-sugeridas/editar', { id: this.rutaSugeridaSeleccionado.ENTIDAD.Id }]);
	}

	getMensajesExpirados(_val) {
		for (const i in this.Estado) {
			if (this.Estado[i].value === _val) {
				return this.Estado[i];
			}
		}
		return {};
	}

	filterEstado(event,col){
		console.log(event.value)
		console.log(col)
		console.log("Se va a filtrar por estado");
		console.log(this.dt_rutas)
		if(event.value.value !== 4){
			this.dt_rutas.filter(event.value.value, col.field, 'equals');
		}else{
			this.dt_rutas.reset();
		}
			
		
		

		//this.filtro.where.ExpiracionMensaje = event.value;
		//this.filtro.page = 0;
		//this.guardarfiltrado();
		//this.loadContenido();
	}


	eliminarRutaSugerida(elemento: any) {
		const that = this;
		this.authService.setRutaSugerida(elemento.Id);
		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR'),
			header: this.translate.instant('MensajesConfirmacion.MENSAJE_CABECERA_CONFIRMACION'),
			icon: 'fa fa-question-circle',
			accept: () => {
				
				that.spinner.style.display = 'inherit';
				
				return that.entityManager.deleteRUTA(elemento.ENTIDAD)
				
				.then(function () {
					that.rutasSugeridas = that.rutasSugeridas.filter((val, i) => val.ENTIDAD.Id !== elemento.ENTIDAD.Id);
					return that.dt_rutas.reset();
				})
				.then(function () {
					
					that.spinner.style.display = 'none';
				})
				.catch(function (e) {
					that.spinner.style.display = 'none';
					that.appComponent.showError(e.message);
					return false;
				});
			},
			reject: () => {
				that.spinner.style.display = 'none';
			}
		});
		
	}

	mostrarEditar(rutaSugerida) {
		if (this.permisos.RutaSugerida_editar_ruta !== 0){
			this.rutaSugeridaSeleccionado = rutaSugerida;
			this.rutaSugeridaSeleccionado.MostrarEdicion = true;
		}
	}

	ocultarEditar(rutaSugerida) {
		if (this.permisos.RutaSugerida_editar_ruta !== 0){
			rutaSugerida.MostrarEdicion = false;
		}
	}


	prepararRutaSugeridasCell(RUTAS_SUGERIDAS): any[] {
		const that = this;
		this.rutasSugeridas = [];
		this.rutasSugeridasDestacar = [];
		const promises: any[] = [];
		// const token = that.authService.getToken();

		RUTAS_SUGERIDAS = RUTAS_SUGERIDAS.sort( (one: RutaSugerida, two: RutaSugerida) => {
			return one.Prioridad > two.Prioridad ? 1 : -1;
		});

		RUTAS_SUGERIDAS.forEach(RUTA_SUGERIDA => {
			const rutaSugerida = new RutaSugerida(RUTA_SUGERIDA);
			const ultima = rutaSugerida.ENTIDAD.FOTOS.length - 1;
			if (ultima >= 0) {
				if (rutaSugerida.ENTIDAD.FOTOS[ultima].UrlFotoExt) {
					rutaSugerida.Imagen = rutaSugerida.ENTIDAD.FOTOS[ultima].UrlFotoExt;
				}
				else{
					rutaSugerida.Imagen =  environment.urlBaseFotos +  rutaSugerida.ENTIDAD.FOTOS[ultima].IdFotoExt;
				}
			}
			else {
				rutaSugerida.Imagen = that.authService.getFotoPorDefecto();
			}

			that.rutasSugeridas.push(rutaSugerida);
		
			if (rutaSugerida && rutaSugerida.PrioridadDestacado !== 0) {
				that.rutasSugeridasDestacar.push(rutaSugerida);
			
			}

		});
		console.log(that.rutasSugeridas)
		return allSettled(promises);
	}

	//función para solo mostrar los primeros 50 caracteres del campo descrpción en la tabla de Rutas Sugeridas
	previewDescripcion(descripcion){
		return descripcion.substring(0,49) + '...';
	}
	
	//#region DESTACADOS
	mostrarFormularioPrioridadDestacar(elementoAsociado){
		
		this.displayDialogPrioridadDestacar = true;
	}

	ocultarFormularioPrioridadDestacar(){
		
		this.displayDialogPrioridadDestacar = false;
	}

	onMostrarFormularioPrioridadDestacar(evento){
		
		//this.dt_rutas_destacadas.filter("Activo", this.cols_destacar[3].field);
		//this.dt_rutas.filter("Activo", this.cols_destacar[3].field);
		
	}

	onOcultarFormularioPrioridadDestacar(event){
		
	}

	guardarDestacados(){

		let i = 1;
		const Destacar_aux = [];

		this.rutasSugeridas.forEach(ruta => {
			const destacado = this.rutasSugeridasDestacar.filter( x => x.Id === ruta.Id)[0];
			if (destacado !== undefined) {

				ruta.PrioridadDestacado = i;
				ruta.Prioridad = i;

				ruta.ENTIDAD.PrioridadDestacado = i;
				ruta.ENTIDAD.Prioridad = i;

				Destacar_aux.push(ruta);
				i = i + 1;
			}
		});

		i = Destacar_aux.length + 1;
		this.rutasSugeridas.forEach(ruta => {
			const destacado = Destacar_aux.filter( x => x.Id === ruta.Id)[0];

			// No es destacado
			if (destacado === undefined) {
				ruta.PrioridadDestacado = 0;
				ruta.Prioridad = i;

				ruta.ENTIDAD.PrioridadDestacado = 0;
				ruta.ENTIDAD.Prioridad = i;

				i = i + 1;
			}
		});

		
		this.entityManager.saveChanges();

		this.ocultarFormularioPrioridadDestacar();
		
	}

	cancelarDestacados(){
		const RUTAS = this.rutasSugeridas.map( x => x.ENTIDAD );

		this.prepararRutaSugeridasCell(RUTAS);
		
		this.ocultarFormularioPrioridadDestacar();
		
	
	}
	//#endregion



	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/RutasSugeridas/RutasSugeridas.component.ts